import { DataBean } from "../DataBean";

export class Airport extends DataBean {



    public async deleteAirport(idAirport: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAirport_Number", [idAirport]);
    }
    public async updateAirport(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.Airport_updateAirport_com.quickdataerp.bean.transportguides.Airport", [bean]);
    }
    public async getAirportCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAirportCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}